import { Swiper } from './swiper-DSEIACnL.js';
import { A as A11y } from './a11y-CNmE74mL.js';
import './utils-CPPFXbqB.js';

class QuickLinksSlider extends HTMLElement {
  #swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.#swiper, {
      modules: [A11y],
      slidesPerView: 'auto',
      spaceBetween: 8,
    });
  }
}

customElements.define('quick-links-slider', QuickLinksSlider);
